"use client";

import { SplashScreen } from "@/components";
import ErrorAlert from "@/components/alerts/errorsAlert";
import ExitoAlert from "@/components/alerts/ExitosAlert";
import React from "react";
import FormEditPassword from "./Components/EditPassword";
import { useEditPassword } from "./Hooks/useEditPassword";

export const EditPasswordClient: React.FC = () => {
  const {
    password,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    onPasswordChange,
    onConfirmPasswordChange,
    isFormValid,
    loading,
    apiError,
    successMessage,
    tokenStatus,
    errorAlertData,
    showSuccessAlert,
    successAlertData,
    showSplash,
    handleSplashFinish,
    onSubmit,
    onCloseErrorAlert,
    onCloseSuccessAlert,
  } = useEditPassword();

  if (showSplash) {
    return <SplashScreen duration={3500} onFinish={handleSplashFinish} />;
  }

  // Splash terminó, pero seguimos validando
  if (tokenStatus === "validating") {
    return (
      <div className="flex justify-center items-center min-h-[300px]">
        <div className="animate-spin h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  // Enlace inválido (cuando sí había parámetro, pero es incorrecto)
  if (tokenStatus === "invalid" && errorAlertData) {
    return (
      <ErrorAlert
        title={errorAlertData.title}
        message={errorAlertData.message}
        onClose={onCloseErrorAlert}
      />
    );
  }

  // Error de API
  if (apiError && !successMessage) {
    return <p className="text-[var(--color-error)]">{apiError}</p>;
  }

  if (tokenStatus === "valid") {
    return (
      <>
        <FormEditPassword
          isFormValid={isFormValid}
          onSubmit={onSubmit}
          password={password}
          confirmPassword={confirmPassword}
          passwordError={passwordError}
          confirmPasswordError={confirmPasswordError}
          onPasswordChange={onPasswordChange}
          onConfirmPasswordChange={onConfirmPasswordChange}
          isCheckboxDisabled={!isFormValid}
          loading={loading}
          apiError={apiError}
          successMessage={successMessage}
        />

        {showSuccessAlert && successAlertData && (
          <ExitoAlert
            title={successAlertData.title}
            message={successAlertData.message}
            onClose={onCloseSuccessAlert}
          />
        )}
      </>
    );
  }
};

export default EditPasswordClient;
